module.exports = __webpack_public_path__ + "static/media/sidebar.3f62cf08.svg";